"use strict";

require(['dcf-toggle-button', 'css!js-css/toggle-button'], function (DCFToggleButtonModule) {
  // Get all the buttons and create the theme
  var toggleButtons = document.querySelectorAll('.dcf-btn-toggle'); // Initialize the buttons with the theme

  var toggleButtonObj = new DCFToggleButtonModule.DCFToggleButton(toggleButtons);
  toggleButtonObj.initialize(); // Add class to toggleElement
  // The toggle button class only has functionality and no ability to add styles

  toggleButtons.forEach(function (toggleButton) {
    var toggleElementId = toggleButton.dataset.controls;
    var toggleElement = document.getElementById(toggleElementId);
    toggleElement.classList.add('unl-btn-toggle-element');
  });
});

define("toggle-button", function(){});

